import React from "react"
import { Box, type BoxProps, Text, type TextProps } from "@chakra-ui/react"

interface SubTitleInterface {
  value: string
  textProps?: TextProps
  boxProps?: BoxProps
}
export const SubTitle = ({ value, textProps, boxProps }: SubTitleInterface): JSX.Element => (
  <Box display={"flex"} justifyContent="center" width="100%" alignItems={"center"} mt="21px" {...boxProps}>
    <Text
      fontFamily={"PT Sans"}
      fontSize="22.5px"
      fontWeight={"400"}
      lineHeight={"26px"}
      display={"inline-block"}
      borderBottomColor={"accent"}
      borderBottomWidth={"2px"}
      paddingBottom="8px"
      px="16px"
      {...textProps}
    >
      {value}
    </Text>
  </Box>
)
